import axios, { AxiosInstance } from 'axios';
import UniversalCookie from 'universal-cookie';
import { convertDates } from '../utils/convert-dates';
import { Constants } from '../utils/constants';

const cookie = new UniversalCookie({ path: '/' });

const client: AxiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
  headers: {
    'X-TenantId': null,
    Authorization: null,
  },
  withCredentials: true,
});

client.interceptors.request.use(async (config) => {
  const tenantId: string | null | undefined = localStorage.getItem(Constants.authorization.tenantId) || null;
  const access_token: string | undefined = cookie.get(Constants.authorization.accessToken) || null;

  config.headers['X-TenantId'] = tenantId;
  if (access_token) {
    config.headers['Authorization'] = `Bearer ${access_token}`;
  }

  return config;
});

const formatErrors = (errors: unknown): string => {
  if (typeof errors === 'string') return errors;
  if (Array.isArray(errors)) return errors.join('; ');
  if (typeof errors === 'object' && errors !== null) {
    const messages = Object.values(errors).flat();
    return messages.join('; ');
  }
  return String(errors);
};

client.interceptors.response.use(
  (response) => {
    convertDates(response.data);
    return response;
  },
  (error) => {
    if (axios.isAxiosError(error) && error.response?.data) {
      const data = error.response.data;
      const message =
        (data.errors ? formatErrors(data.errors) : null) ||
        data.message ||
        data.title ||
        (typeof data === 'string' ? data : null);
      if (message) {
        error.message = message;
      }
    }
    return Promise.reject(error);
  }
);

export default client;
